import { enqueueTask, cookieExists } from '../util/common';
/* eslint-disable no-undef */
class ExternalScripts {
    init () {
        this.liveChatConfig = {};
        try {
            // .dataset automatically converts data to CamelCase
            var config = document.getElementById('livechat-config').dataset;
            this.liveChatConfig = config;

            if (config.legacyScript === true || config.legacyScript === 'true') {
                this.liveagentInitLegacy();
                setTimeout(function () {
                    var chatId = $('#scriptId').attr('scriptId');
                    var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);

                    if (onlineBtn && onlineBtn.style.display !== 'none') {
                        $('.not-available-chat').addClass('hidden');
                        $('.available-chat').removeClass('hidden');
                    } else {
                        $('.not-available-chat').removeClass('hidden');
                        $('.available-chat').addClass('hidden');
                    }
                    $('.availabilityContainer').css('display', 'none');
                }, 5000);
            } else {
                enqueueTask(this.liveagentInit.bind(this));
            }
            this.proactiveChatInit();
        } catch (e) {
            // Livechat might not be included in the page
        }
    }

    setAvailability () {
        var chatId = $('#scriptId').attr('scriptId');
        var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);

        if (onlineBtn && onlineBtn.style.display !== 'none') {
            $('.not-available-chat').addClass('hidden');
            $('.available-chat').removeClass('hidden');
        } else {
            $('.not-available-chat').removeClass('hidden');
            $('.available-chat').addClass('hidden');
        }
        $('.availabilityContainer').css('display', 'none');
    }

    openLiveChat () {
        var chatId = this.getChatId();
        var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);
        if (onlineBtn && onlineBtn.style.display !== 'none') {
            $('.js-chat-show').removeClass('show');
            $('.overlay-bubble-chat').hide();
            onlineBtn.click();
        }
    }

    getChatId () {
        return this.liveChatConfig['staticChatId'];
    }

    proactiveChatInit () {
        let liveChatContainer = 'livechat-desktop';
        if (!Foundation.MediaQuery.is('medium')) {
            liveChatContainer = 'livechat-mobile';
        }

        var scriptContainer = document.getElementById(liveChatContainer);
        if (scriptContainer) {
            $('body').append(scriptContainer.innerHTML);
        }
    }

    liveagentInitLegacy () {
        const livechatConfigElement = document.getElementById('livechat-config');
        if (!livechatConfigElement) {
            return false;
        }

        // Show legacy bubble
        $('.legacy-bubble-chat').removeClass('hide');

        this.liveChatConfig = livechatConfigElement.dataset;

        /* global liveagent */
        liveagent.addCustomDetail('siteLanguage', this.liveChatConfig.language);
        if (this.liveChatConfig.customerName && this.liveChatConfig.customerEmail) {
            liveagent.addCustomDetail('customerName', this.liveChatConfig.customerName);
            liveagent.addCustomDetail('customerEmail', this.liveChatConfig.customerEmail);
        }

        if (document.getElementById('liveChatCurrentCountry')) {
            const liveChatCurrentCountry = document.getElementById('liveChatCurrentCountry').getAttribute('currentCountry');
            liveagent.addCustomDetail('siteCountry', liveChatCurrentCountry);
        }

        liveagent.init(this.liveChatConfig.initParam1, this.liveChatConfig.initParam2, this.liveChatConfig.initParam3);
        if (!window._laq) { window._laq = []; }
        window._laq.push(() => {
            if ($('#checkout-main').length === 0) {
                liveagent.showWhenOnline(this.liveChatConfig.staticChatId,
                    document.getElementById('liveagent_button_online_' + this.liveChatConfig.staticChatId));
                liveagent.showWhenOffline(this.liveChatConfig.staticChatId,
                    document.getElementById('liveagent_button_offline_' + this.liveChatConfig.staticChatId));
            }
        });

        $(document).on('click', '.js-live-chat', (e) =>
            this.openLiveChat()
        );

        var chatId = $('#scriptId').attr('scriptId');

        var observer = new MutationObserver(function (mutations) {
            var chatId = $('#scriptId').attr('scriptId');
            var onlineBtn = document.getElementById(`liveagent_button_online_` + chatId);

            if (onlineBtn && onlineBtn.style.display !== 'none') {
                $('.not-available-chat').addClass('hidden');
                $('.available-chat').removeClass('hidden');
            } else {
                $('.not-available-chat').removeClass('hidden');
                $('.available-chat').addClass('hidden');
            }
            $('.availabilityContainer').css('display', 'none');
        });
        var target = document.querySelector('#liveagent_button_online_' + chatId);
        observer.observe(target, {
            attributes: true
        });
    }

    liveagentInit () {
        var _self = this;

        if (!window.embedded_svc || !window.embedded_svc.menu) {
            var s = document.createElement('script');
            s.setAttribute('src', this.liveChatConfig.script);
            s.onload = function () {
                _self.initESW(null);
            };
            document.body.appendChild(s);
        } else {
            this.initESW(this.liveChatConfig.initUrl);
        }
    }

    initESW (url) {
        embedded_svc.menu.settings.language = `${this.liveChatConfig.language}`;
        embedded_svc.menu.chat.settings.paramName = `${this.liveChatConfig.customerName}`;
        embedded_svc.menu.chat.settings.paramMail = `${this.liveChatConfig.customerEmail}`;
        embedded_svc.menu.chat.settings.paramBrand = `${this.liveChatConfig.brand}`;
        embedded_svc.menu.chat.settings.paramCountry = `${this.liveChatConfig.country}`;

        embedded_svc.menu.init(
            `${this.liveChatConfig.initParam1}`,
            `${this.liveChatConfig.initParam2}`,
            url,
            `${this.liveChatConfig.initParam3}`,
            `${this.liveChatConfig.initParam4}`,
            {
                pageName: `${this.liveChatConfig.pageName}`
            }
        );

        this.appendEmbeddedStyling();
    }

    appendEmbeddedStyling () {
        var paramMobPosition = parseInt(this.liveChatConfig.position);

        var styleEmb = document.createElement('style');
        styleEmb.type = 'text/css';
        styleEmb.innerHTML = '.embedded-service .channelmenu_ctas li a { font-size: small;font-weight: normal;}';
        var isProductionEnvironment = this.liveChatConfig.isProductionEnvironment === true || this.liveChatConfig.isProductionEnvironment === 'true';
        if (isProductionEnvironment && !(cookieExists('cookie_closed') || (cookieExists('OptanonAlertBoxClosed') && cookieExists('OptanonConsent')))) {
            styleEmb.innerHTML += ' .embedded-service { display:none;}';
        }
        styleEmb.innerHTML += ' .embedded-service .fab:hover:before, .embedded-service .fab:focus:before { background-color: #F4F1EB !important;}';
        styleEmb.innerHTML += ' .embedded-service .fab:focus { background-color: #F4F1EB !important; box-shadow: 2px 2px 5px 0 rgba(45,45,45,0.5) !important;}';
        if (Foundation.MediaQuery.atLeast('medium')) {
            // Style innerHTML button menu
            styleEmb.innerHTML += ' .embedded-service .fab {bottom: 48px !important;right: 42px !important;z-index:1000 !important;}';
            // menu items
            styleEmb.innerHTML += ' .embedded-service .channelmenu {bottom: 123px !important;right: 42px !important;z-index:1000 !important;}';
            // menu minimize button
            styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 42px !important;}';
            styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom: 48px !important;right:42px !important;}';
            // chat container
            styleEmb.innerHTML += ' .embeddedServiceSidebar.layout-float .dockableContainer {bottom: 123px !important;right: 42px !important;}';
        } else {
            if (paramMobPosition == 1) {
                // Style innerHTML button menu TOP (Checkout)
                styleEmb.innerHTML += ' .embedded-service .fab {bottom:unset !important;top:1px !important;right: 15px !important;z-index:1000 !important;}';
                styleEmb.innerHTML += ' .embedded-service .channelmenu {bottom:unset !important;top:76px;z-index:1000 !important;display: initial !important;}';
                // menu minimized
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {bottom:unset !important;top:76px !important;}';
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom:unset !important;top:1px !important;right: 15px !important;}';
            } else if (paramMobPosition == 2) {
                // Style innerHTML button menu Middle (Listing)
                styleEmb.innerHTML += ' .embedded-service .fab {bottom:24px !important;right: 8px !important;z-index:998 !important;}';
                // menu items
                styleEmb.innerHTML += ' .embedded-service .channelmenu {bottom:99px !important;z-index:997 !important;display: initial !important;}';
                // menu minimize button
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 8px !important;}';
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom:24px !important;right: 8px !important;}';
            } else if (paramMobPosition == 3) {
                // Style innerHTML button menu Middle (only for Cart page)
                styleEmb.innerHTML += ' .embedded-service .fab {bottom:125px !important;right: 8px !important;z-index:998 !important;}';
                // menu items
                styleEmb.innerHTML += ' .embedded-service .channelmenu {bottom:99px !important;z-index:997 !important;display: initial !important;}';
                // menu minimize button
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right: 8px !important;}';
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom:125px !important;right: 8px !important;}';
            } else {
                // Style innerHTML button menu (Homepage + Pdp)
                styleEmb.innerHTML += ' .embedded-service .fab {bottom:168px !important;right:8px !important;z-index:998 !important;}';
                // menu items
                styleEmb.innerHTML += ' .embedded-service .channelmenu {bottom:128px !important;z-index:997 !important;display: initial !important;}';
                // menu minimize button
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI .content {right:8px !important;}';
                styleEmb.innerHTML += ' .embeddedServiceSidebarMinimizedFabDefaultUI {bottom:168px !important;right:8px !important;}';
            }
        }
        document.getElementsByTagName('head')[0].appendChild(styleEmb);
    }
}

const external = new ExternalScripts();
window.openLiveChat = external.openLiveChat;
export default external;